import { render, staticRenderFns } from "./SellOutBySize.vue?vue&type=template&id=0da28116&scoped=true&"
import script from "./SellOutBySize.vue?vue&type=script&lang=js&"
export * from "./SellOutBySize.vue?vue&type=script&lang=js&"
import style0 from "./SellOutBySize.vue?vue&type=style&index=0&id=0da28116&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da28116",
  null
  
)

export default component.exports